import React, { useState, } from 'react';
import { Typography, Button, Space } from 'antd';
import { AccessManagementDeleteUserModal } from '../Modals/AccessManagementDeleteUserModal.component';

const { Title } = Typography;

export const DeleteUser = ({...props}) => {

    const { user } = props;

    const [displayModal, setDisplayModal] = useState(false);

    return(
        <>  
            <div className='account__delete-user'>
                <div className='account__edit-form-container'>
                    <Title level={5}>Delete User</Title>
                    <Space size='large' direction='vertical'>
                        <p>Deleting a user will result in removing all information and permissions.</p>
                        <Button danger onClick={() => setDisplayModal(true)}>Delete User</Button>
                    </Space>
                </div>
            </div>
            
            { displayModal && 
                <AccessManagementDeleteUserModal
                    user={user}
                    displayModal={displayModal} 
                    setDisplayModal={setDisplayModal}
                    />
            }
        </>
    )
};